<template>
    <v-card outlined class="rounded-lg pa-2">
        <v-card-subtitle class="pa-1 pb-2">
            <v-icon small left>mdi-format-list-bulleted</v-icon>
            {{ label }}
            <v-spacer></v-spacer>
        </v-card-subtitle>
        <v-row v-for="(entry, index) in localList" :key="index" align="center" class="ma-0 pa-0">
            <v-col cols="10" class="pa-1">
                <v-text-field
                    outlined dense hide-details
                    class="rounded-lg"
                    v-model="localList[index]"
                    @input="emitChange"
                ></v-text-field>
            </v-col>
            <v-col cols="2" class="pa-1 text-right">
                <v-btn icon small color="red" @click="removeItem(index)" :disabled="localList.length <= 1">
                    <v-icon>mdi-delete</v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <v-row class="ma-0 pa-0">
            <v-col cols="12" class="pa-1">
                <v-btn small text color="primary" @click="addItem">
                    <v-icon left>mdi-plus</v-icon>Ajouter un élément
                </v-btn>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
export default {
    name: 'ListEditor',
    props: {
        // v-model: array of strings
        value: {
            type: Array,
            default: () => []
        },
        label: {
            type: String,
            default: 'Liste'
        }
    },
    data () {
        return {
            localList: []
        }
    },
    watch: {
        value: {
            immediate: true,
            handler (newVal) {
                this.localList = Array.isArray(newVal) ? [...newVal] : []
            }
        }
    },
    methods: {
        addItem () {
            this.localList.push('')
            this.emitChange()
        },
        removeItem (index) {
            this.localList.splice(index, 1)
            this.emitChange()
        },
        emitChange () {
            // Filter out empty entries before emitting
            const cleaned = this.localList.map(s => s).filter(s => s !== null && s !== undefined)
            this.$emit('input', cleaned)
            this.$emit('change', cleaned)
        }
    }
}
</script>
